import { useContext, useState } from "react";
import { useNavigate } from "react-router";
import { ROUTES_PATH } from "../../constants";
import { CreditProposalResultContext } from "../../contexts/CreditProposalResultContext";
import { NotificationType } from "../../interfaces/NotificationType";
import CreditProposalService from "../../services/CreditProposal";
import { OperationShippingForm } from "./../../components/OperationShippingForm/OperationShippingForm";
import { CreditProposalFlowStep } from "../../interfaces/CreditProposalResult";

interface OperationShippingProps {
  loadingEvent: (data: boolean) => void;
}

export const OperationShipping: React.FC<OperationShippingProps> = ({
  loadingEvent,
}) => {
  const navigate = useNavigate();
  const { creditProposalResult } = useContext(CreditProposalResultContext);
  const [methodRecieved, setMethodRecieved] = useState<boolean>(false);

  const handleMethodSelected = async (notificationType: NotificationType) => {
    if (creditProposalResult && !methodRecieved) {
      setMethodRecieved(true);
      try {
        await CreditProposalService.sendNotification(
          creditProposalResult.credit_proposal_id,
          notificationType
        );
        navigate(ROUTES_PATH.OPERATION_SHIPPING_FINISHED);
      } catch (error) {
        // Si da error DRF0036 es porque se ha superado el límite de notificaciones permitidas (3)
        navigate(ROUTES_PATH.UNKNOWN_ERROR);
      }
    }
  };

  const shallShowBtn = () => {
    if (
      (creditProposalResult?.product === "PLS" &&
        creditProposalResult?.flow_step !== CreditProposalFlowStep.UPDATE_IBAN &&
        creditProposalResult?.flow_step !== CreditProposalFlowStep.BANK_READER &&
        creditProposalResult?.flow_step !== CreditProposalFlowStep.OCR) ||
      creditProposalResult?.product === "CEX" ||
      creditProposalResult?.product === "SUS"
    ) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <OperationShippingForm
      showContinueBtn={shallShowBtn()}
      operationMethod={handleMethodSelected}
      loadingRequest={() => loadingEvent(true)}
    />
  );
};
